import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DataService} from '../../../services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  public email: string;
  public isUploadXsl = false;
  public fileName: string;

  private formData = new FormData();

  @Output() upload: EventEmitter<string> = new EventEmitter();
  @ViewChild('file', {static: false}) public file: ElementRef;

  
  constructor(
    public activeModal: NgbActiveModal,
    private service: DataService
  ) {
  }

  ngOnInit() {
  }

  public chooseFile(file) {
    const f = file.target.files[0] as File;
    const reader = new FileReader();
    // this.isUploadXsl = true;
    reader.readAsDataURL(f);
    reader.onload = (event) => {
      this.formData.append('file', f);
      this.fileName = this.formData.get('file')['name'];
    }
  }

  add() {
    if (!this.fileName) {
      this.activeModal.close(this.email);
    } else {
      this.isUploadXsl = true;
      this.service.uploadXslUsers(this.formData).subscribe(response => {
        this.isUploadXsl = false;
        this.fileName = null;
        this.activeModal.close('file_upload');
      });
    }
  }
}
